<template>
  <p class="btn yes">
    <a @click="plusOne">
      <span class="icon"
        ><img src="../assets/img/common/btn_icon_yes.png" alt="" /></span
      ><span class="txt">好き!</span>
    </a>
  </p>
</template>
<script>
export default {
  name: "LikeBtn",
  props: {
    quests: {},
    val: {
      type: Number,
    },
  },
  data: function () {
    return {
      value: 0,
      question: {},
    };
  },
  methods: {
    plusOne: function () {
      this.value = this.val;
      this.question = this.quests;
      this.value += 1;
      var select = this.question.shift();
      var selectImg = true;
      var show = false;
      this.$emit("updated", this.value, this.question, selectImg, show);
      this.$store.commit("updateLike", select);
    },
  },
};
</script>